<template>  
  <div class="container-fluid">
    <div ref="widthContainer" class="row justify-content-center">
      <div class="col-12 col-md-12">             
        <div class="single-image text-center">
            <img :src="`./assets/${iconos_url}.png`" alt="de">
            <div>
              <h4>{{ titulo_categoria }}</h4>
            </div>
        </div>
        <CategoryPreguntas :data_preguntas="filteredPreguntas" />        
      </div>        
    </div>   
  </div>
</template>

<script>

import IframeResizer from '@/utils/iframe-resizer'
import { mapState } from 'vuex'
import { filter, kebabCase } from 'lodash'

import CategoryPreguntas from '@/components/CategoryPreguntas'


export default {
  name: 'singlecategory',
  components: {
    CategoryPreguntas

  },
  props: {
    partyData: Array
  },
  data() {
    return {
      preguntaItem: {},
      widthContainer: 0,
      iconos_url: 'Pulso del pais',
      titulo_categoria: 'Pulso del pais'
    }
  },
  mounted () {
    this.iconos_url = this.$route.params.categoria      
    this.titulo_categoria = this.$route.params.categoria
    
    IframeResizer.create()
    
    this.widthContainer = this.$refs['widthContainer'].offsetWidth
    window.addEventListener('resize', () => {
      this.widthContainer = this.$refs['widthContainer'].offsetWidth
		})
  },
  methods: {
    kebabCase
  },
  computed: {
    ...mapState({
      data_preguntas: state => state.encuesta.data_preguntas,     
    }),
    filteredPreguntas() {
       let categoria_url = this.$route.params.categoria       
      return filter(this.data_preguntas, (item) => {        
        if(kebabCase(item.category) == categoria_url){
          return item
        }
      })
    }
  }
}
</script>